/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { organizationsListInvites } from "../funcs/organizationsListInvites.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListInvitesResult } from "../models/components/listinvitesresult.js";
import {
  ListInvitesRequest,
  ListInvitesSecurity,
} from "../models/operations/listinvites.js";
import { unwrapAsync } from "../types/fp.js";
export type ListInvitesQueryData = ListInvitesResult;

export function prefetchListInvites(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListInvitesRequest | undefined,
  security?: ListInvitesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListInvitesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListInvitesQuery(
  client$: GramCore,
  request?: ListInvitesRequest | undefined,
  security?: ListInvitesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<ListInvitesQueryData>;
} {
  return {
    queryKey: queryKeyListInvites({ gramSession: request?.gramSession }),
    queryFn: async function listInvitesQueryFn(
      ctx,
    ): Promise<ListInvitesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(organizationsListInvites(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListInvites(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "organizations", "listInvites", parameters];
}
